import { Box, FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import type { ActiveQualificationWithLicenses } from "../hooks/useActiveQualificationsWithLicenses";
import type { StepProps } from "../types";

interface QualificationSelectionStepProps extends StepProps {
  activeQualifications: ActiveQualificationWithLicenses[];
}

export function QualificationSelectionStep({
  state,
  actions,
  activeQualifications,
}: QualificationSelectionStepProps) {
  return (
    <Box>
      <RadioGroup
        value={state.selectedQualificationId ?? ""}
        onChange={(event) => {
          actions.handleQualificationSelect(event.target.value);
        }}
      >
        <Stack spacing={3}>
          {activeQualifications.map((item) => (
            <FormControlLabel
              key={item.qualification.id}
              value={item.qualification.id}
              control={<Radio />}
              labelPlacement="start"
              label={<Text variant="body1">{item.qualification.attributes.displayLabel}</Text>}
              sx={(theme) => ({
                width: "100%",
                justifyContent: "space-between",
                margin: theme.spacing(0),
              })}
            />
          ))}
        </Stack>
      </RadioGroup>
    </Box>
  );
}
